module.exports = __webpack_public_path__ + "static/media/Product_Heart_no_shadow.ad705664.svg";